// src/config/domains.js
// Source unique de vérité pour les adresses des sites ARTKIV / ARTICHAUT.
//
// Deux applications distinctes coexistent aujourd'hui :
// - ARTKIV_APP_URL : l'application principale (ce dépôt) — connexion, compte,
//   collection, orientation, tarifs. Domaine actuel : artkiv.com.
// - VISION_URL : l'application Vision séparée (ArtkivVisionApp) — quiz
//   collectionneur, démos IA, questionnaire héritier. Domaine actuel :
//   vision.artkiv.com.
//
// Toujours importer ces constantes plutôt que de coder un domaine en dur :
// c'est ce qui permettra de changer de domaine (migration ARTICHAUT) en un
// seul endroit plutôt qu'en cherchant/remplaçant dans des dizaines de fichiers.

export const ARTKIV_APP_URL = process.env.REACT_APP_APP_URL || "https://artkiv.com";

// Garde-fou de marque : un visiteur de *.artichaut.eu ne doit JAMAIS être envoyé vers
// vision.artkiv.com, même si REACT_APP_VISION_URL a été oublié au build (.env.production
// fixe l'adresse ARTKIV par défaut). Le domaine réellement servi prime sur la variable.
const onArtichautHost =
  typeof window !== "undefined" && /(^|\.)artichaut\.eu$/i.test(window.location.hostname);
export const VISION_URL = onArtichautHost
  ? "https://vision.artichaut.eu"
  : process.env.REACT_APP_VISION_URL || "https://vision.artkiv.com";

// Adresses AFFICHÉES au public (pages bêta, contrat, pied de page) : elles suivent la marque du build.
// ARTKIV : artkiv.com / vision.artkiv.com ; ARTICHAUT : artichaut.eu / vision.artichaut.eu.
// Les adresses email (support@artkiv.com) et le nom de l'entité (ARTKIV, QUANG & CO) ne changent pas.
const hostnameOf = (url, fallback) => {
  try { return new URL(url).hostname; } catch { return fallback; }
};
export const VISION_HOST = hostnameOf(VISION_URL, "vision.artkiv.com");
export const ROOT_HOST = hostnameOf(ARTKIV_APP_URL, "artkiv.com").replace(/^(app|www)\./, "");
export const ROOT_URL = `https://${ROOT_HOST}`;

// API du module Vision (OCR, reconnaissance visuelle) — sous-domaine distinct.
export const VISION_API_URL = process.env.REACT_APP_VISION_API_URL || "https://api.vision.artkiv.com";

// API du serveur principal (Hetzner), distincte de l'API Vision ci-dessus.
export const ARTKIV_API_URL = process.env.REACT_APP_API_BASE_URL || "https://api.artkiv.com";

// ─── Migration ARTICHAUT (Phase 2 — préparation, pas encore actif) ─────────
// Futures adresses une fois la bascule de domaine faite. Tant que ces
// domaines ne sont pas réellement en ligne, ces constantes ne servent qu'à
// être ajoutées AUX CÔTÉS des domaines actuels dans les listes d'origines
// autorisées (auth cross-domaine) — jamais à la place.
export const ARTICHAUT_APP_URL = "https://app.artichaut.eu";
export const ARTICHAUT_VISION_URL = "https://vision.artichaut.eu";

// Toutes les origines de confiance pour l'authentification cross-domaine
// (postMessage entre artkiv-app et ArtkivVisionApp). Pendant la transition,
// les domaines actuels ET futurs doivent fonctionner en parallèle — ne jamais
// retirer une entrée ici tant que la bascule correspondante n'est pas faite.
export const TRUSTED_AUTH_ORIGINS = [
  ARTKIV_APP_URL,
  VISION_URL,
  ARTICHAUT_APP_URL,
  ARTICHAUT_VISION_URL,
];

// Domaine de cookie partagé entre les applications ci-dessus (sans le
// "https://", avec le point initial — voir src/lib/cookieStorage.js).
// Calculé dynamiquement : un cookie ne peut avoir qu'un seul domaine à la
// fois, qui doit correspondre au domaine réellement servi par le navigateur.
export const COOKIE_DOMAIN = ".artkiv.com"; // conservé pour compatibilité — voir getCookieDomain()

export function getCookieDomain() {
  if (typeof window === "undefined") return COOKIE_DOMAIN;
  return window.location.hostname.endsWith("artichaut.eu")
    ? ".artichaut.eu"
    : ".artkiv.com";
}

// Adresse email de support affichée aux clients.
export const SUPPORT_EMAIL = "support@artkiv.com";
